import React from 'react';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import 'CSS/demand-supply/demand-supply.scss';

function DiscardDialog({
  isOpen,
  handleClose,
  title,
  message,
  action,
  buttonTxtConfirm,
}) {
  return (
    <Dialog
      maxWidth={'xs'}
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{title}</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={action} variant="contained" color="primary">
          {buttonTxtConfirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DiscardDialog;
